<ion-item class="attachment-followup-item">
    <ion-thumbnail item-start>
        <img [src]="getImageUrl()"/>
    </ion-thumbnail>
    <p>{{this.data.Title}}</p>
</ion-item>
